import { render, staticRenderFns } from "./components-block.vue?vue&type=template&id=89477f02&scoped=true"
import script from "./components-block.ts?vue&type=script&lang=js&external"
export * from "./components-block.ts?vue&type=script&lang=js&external"
import style0 from "./components-block.vue?vue&type=style&index=0&id=89477f02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89477f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89477f02')) {
      api.createRecord('89477f02', component.options)
    } else {
      api.reload('89477f02', component.options)
    }
    module.hot.accept("./components-block.vue?vue&type=template&id=89477f02&scoped=true", function () {
      api.rerender('89477f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/components-tab/components-block.vue"
export default component.exports